import React from 'react';
import '../../styles/onboardingFlow/onboardingComponents/integrationCard.scss';
import CustomSVGs from '../../ui/customSVGs/CustomSVGs';
import {
  linkSVG,
  warningSVG,
  infoSVG,
  settingSVG,
  successSVG,
} from '../../lib/allCustomSVGs';

interface IntegrationCardProps {
  mcp: any;
  onClick: () => void;
  image: string;
  title: string;
  description: string;
  isActive: boolean;
  hasOAuth: boolean;
  isInvalid?: boolean;
  needsOAuthConsent?: boolean;
}

const IntegrationCard: React.FC<IntegrationCardProps> = ({
  mcp,
  onClick,
  image,
  title,
  description,
  isActive,
  hasOAuth,
  isInvalid = false,
  needsOAuthConsent = false,
}) => {
  return (
    <div className='integrationCard'>
      {isInvalid && (
        <div className='integrationCard__warning' title='Invalid credentials'>
          <CustomSVGs svg={warningSVG} />
        </div>
      )}
      {isActive && !isInvalid && (
        <div className='integrationCard__badge'>• Activated</div>
      )}
      {isActive && isInvalid && (
        <div className='integrationCard__badge integrationCard__badge--invalid'>
          • Invalid
        </div>
      )}
      {!isActive && (
        <div className='integrationCard__info-icon' title={title}>
          <CustomSVGs svg={infoSVG} />
        </div>
      )}
      <div className='integrationCard__content'>
        <div className='integrationCard__icon'>
          <img src={image} alt={title} />
        </div>
        <div className='integrationCard__header'>
          <h3 className='integrationCard__title'>{title}</h3>
        </div>
        <p className='integrationCard__description'>{description}</p>
        <div className='integrationCard__actions'>
          {isActive ? (
            <div className='integrationCard__status-wrapper'>
              <div
                className={`integrationCard__status ${
                  isInvalid ? 'integrationCard__status--invalid' : ''
                }`}
                onClick={onClick}
              >
                <CustomSVGs svg={isInvalid ? warningSVG : successSVG} />
                <span className='integrationCard__status-text'>
                  {isInvalid ? 'Invalid' : 'Connected'}
                </span>
              </div>
              <div className='integrationCard__gear-icon' onClick={onClick}>
                <CustomSVGs svg={settingSVG} />
              </div>
            </div>
          ) : (
            <div className='integrationCard__connect-wrapper'>
              <button
                type='button'
                className='integrationCard__connect-button'
                onClick={onClick}
              >
                <span>Connect</span>
                {hasOAuth && <CustomSVGs svg={linkSVG} />}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IntegrationCard;
